import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { CarouselIndicator, CarouselIndicators, useCarousel } from "@/components/ui/carousel";

import { HEADER_ID } from "./constants";

export function Indicators() {
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [headerElement, setHeaderElement] = useState<HTMLElement | null>(null);

  const { api } = useCarousel();

  useEffect(() => {
    if (!api) {
      return;
    }

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  useEffect(() => {
    const header = document.getElementById(HEADER_ID);
    if (header) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHeaderElement(header);
    }
  }, []);

  const renderIndicators = (className?: string) => {
    return (
      <CarouselIndicators className={className}>
        {Array.from({ length: count }).map((_, index) => (
          <CarouselIndicator key={index} isActive={current === index} index={index} />
        ))}
      </CarouselIndicators>
    );
  };

  return (
    <>
      {renderIndicators("tablet:hidden flex justify-center")}
      {headerElement &&
        createPortal(renderIndicators("hidden tablet:flex justify-end"), headerElement)}
    </>
  );
}
